import styles from "./styles.module.css";
import { GrClose } from "react-icons/gr";
import { HTMLAttributes } from "react";

type ModalProps = HTMLAttributes<HTMLDivElement> & {
  titulo: string;
  fechar: Function;
  apenasFechar?: boolean;
};

export function Modal({ titulo, fechar, apenasFechar, ...props }: ModalProps) {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <p>{titulo}</p>
          <GrClose className={styles.close} onClick={() => fechar()} />
        </div>

        <div className={styles.modalBody} {...props}></div>

        <div className={styles.modalFooter}>
          {apenasFechar ? (
            <button type="button" onClick={() => fechar()}>Fechar</button>
          ) : (
            <>
              <button type="button" onClick={() => fechar()}>Cancelar</button>
              <button type="submit">Confirmar</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
